(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cloudwash-colour-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cw-colour-gallery')) {
    customElements.define('cw-colour-gallery', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.getRootNode().addEventListener('change', event => {
          const input = event.target;
          if (input.matches?.('#cw-product-form [data-cw-label]') && input.checked) this.selectVariant(input.dataset.cwVariant);
        }, {capture: true, signal});
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-cw-photo')) this.goTo(Number(button.dataset.cwPhoto));
          if (button.hasAttribute('data-cw-prev')) this.goTo(this.index - 1);
          if (button.hasAttribute('data-cw-next')) this.goTo(this.index + 1);
        }, {signal});
        this.addEventListener('keydown', event => {
          if (!event.target.matches('[data-cw-track]')) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          this.goTo(event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, {signal});
        this.bindTrack();
      }
      disconnectedCallback() { this.abort?.abort(); this.trackAbort?.abort(); }
      selectVariant(variantId) {
        if (variantId === this.dataset.variantId) return;
        const template = Array.from(this.querySelectorAll('template[data-cw-variant-id]')).find(item => item.dataset.cwVariantId === variantId);
        if (!template) return;
        this.querySelector('[data-cw-gallery-body]').replaceChildren(template.content.cloneNode(true));
        this.dataset.colour = template.dataset.cwColour;
        this.dataset.variantId = variantId;
        this.bindTrack();
      }
      bindTrack() {
        this.trackAbort?.abort();
        this.trackAbort = new AbortController();
        this.track = this.querySelector('[data-cw-track]');
        this.slides = Array.from(this.querySelectorAll('[data-cw-slide]'));
        this.index = 0;
        if (!this.track) return;
        this.track.addEventListener('scroll', () => {
          if (!this.track.clientWidth) return;
          const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
          if (index !== this.index) { this.index = index; this.updateControls(); }
        }, {passive: true, signal: this.trackAbort.signal});
        this.updateControls();
      }
      goTo(index) {
        const next = Math.max(0, Math.min(index, this.slides.length - 1));
        this.track?.scrollTo({left: next * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      updateControls() {
        this.querySelectorAll('[data-cw-photo]').forEach(button => button.setAttribute('aria-current', String(Number(button.dataset.cwPhoto) === this.index)));
        const previous = this.querySelector('[data-cw-prev]');
        const next = this.querySelector('[data-cw-next]');
        if (previous) previous.disabled = this.index === 0;
        if (next) next.disabled = this.index >= this.slides.length - 1;
        const position = this.querySelector('[data-cw-position]');
        if (position) position.textContent = `${this.index + 1} / ${this.slides.length}`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
